'use strict';

/**
 * Collection for the collection fields
 *
 * @category   Collection
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var CollectionFieldModel = require('modules/base/models/collection-field');

var CollectionFieldsCollection = Collection.extend({
    api: '/core/columns',

    name: 'base:collection-fields',

    model: CollectionFieldModel,

    sortDefault: 'groupOrder.asc-sortPosition.asc',

    initialize: function(options) {
        Collection.prototype.initialize.apply(this, arguments);

        // Listen for reset
        // this.listenTo(App.radio('base').vent, 'collection-fields:reset-selection', this.resetSelection.bind(this));

        // Listen for selection
        // this.listenTo(App.radio('base').vent, 'collection-fields:selection-changed', this.selectionChanged.bind(this));
    },

    resetSelection: function() {
        this.each(function(model) {
            model.set({importSelected: false}, {silent: true});
        }.bind(this));
    },

    /**
     * Is triggered from import, when an item has been selected or deselected
     * @param {string}       fieldname         The fieldname that has been selected
     * @param {string|null}  previousFieldname The previous fieldname, if available
     * @param {boolean}      selected          Is item selected
     */
    selectionChanged: function(fieldname, previousFieldname, selected) {
        var model = this.findWhere({fieldname: fieldname});
        if (model) {
            model.set('importSelected', !!selected);
        }

        // Set previous as unselected
        if (previousFieldname) {
            var previousModel = this.findWhere({fieldname: previousFieldname});
            if (previousModel) {
                previousModel.set('importSelected', false);
            }
        }
    },
});

module.exports = CollectionFieldsCollection;